export enum OrderStreakTrackEnum {
  none = 'none',
  onGoing = 'ongoing',
  lose = 'lose',
}
